import React from 'react';
import { motion } from 'framer-motion';

const steps = [
  {
    number: '01',
    title: 'Create Your Profile',
    description: 'Build a comprehensive profile showcasing your academic achievements, athletic performance, and rowing experience.',
  },
  {
    number: '02',
    title: 'Explore Programs',
    description: 'Browse through 200+ college rowing programs, filter by your preferences, and discover your best matches.',
  },
  {
    number: '03',
    title: 'Connect with Coaches',
    description: 'Reach out directly to college coaches, share your profile, and start meaningful conversations about your future.',
  },
  {
    number: '04',
    title: 'Track Your Progress',
    description: 'Monitor your recruitment journey, manage communications, and stay organized throughout the process.',
  },
];

const HowItWorks: React.FC = () => {
  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-b from-rowing-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center"
        >
          <h2 className="text-4xl font-display font-bold text-rowing-navy">
            Your Journey to College Rowing
          </h2>
          <p className="mt-4 text-xl text-rowing-gray-600 max-w-3xl mx-auto">
            Four simple steps to connect with your dream rowing program
          </p>
        </motion.div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <motion.div
              key={step.number}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative"
            >
              {/* Connection line */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-full w-full h-0.5 bg-rowing-gray-200 -z-10" />
              )}
              
              <div className="text-center">
                <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-rowing-blue text-white text-2xl font-bold mx-auto">
                  {step.number}
                </div>
                <h3 className="mt-6 text-xl font-semibold text-rowing-navy">
                  {step.title}
                </h3>
                <p className="mt-3 text-rowing-gray-600">
                  {step.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-16 text-center"
        >
          <button className="btn-primary text-lg px-8 py-4">
            Get Started Today
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default HowItWorks;